import { render, staticRenderFns } from "./RejectAll.vue?vue&type=template&id=475640bb"
import script from "./RejectAll.vue?vue&type=script&lang=js"
export * from "./RejectAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports